import { render } from "./InvitHelp.vue?vue&type=template&id=2151861e"
import script from "./InvitHelp.vue?vue&type=script&lang=js"
export * from "./InvitHelp.vue?vue&type=script&lang=js"

import "./InvitHelp.vue?vue&type=style&index=0&id=2151861e&lang=scss"

import exportComponent from "/opt/app-root/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__